/** Flat Button — Gegenstück zu Win11Theme::DrawFlatButton(). */

export interface ButtonOptions {
  /** accent = true zeichnet die gefüllte Primäraktion (Connect/Send). */
  accent?: boolean;
  /** Entspricht bgOverride (Record-Blink, Disconnect-Rot); erzwingt helle Schrift. */
  backgroundOverride?: string;
  title?: string;
  disabled?: boolean;
  onClick?: (event: MouseEvent) => void;
}

export function createButton(text: string, options: ButtonOptions = {}): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'cm-btn';
  button.textContent = text;

  if (options.accent) button.classList.add('cm-btn--accent');
  if (options.backgroundOverride !== undefined) {
    button.classList.add('cm-btn--override');
    button.style.setProperty('--cm-btn-bg', options.backgroundOverride);
  }
  if (options.title !== undefined) button.title = options.title;
  if (options.disabled) button.disabled = true;
  if (options.onClick) button.addEventListener('click', options.onClick);

  return button;
}

/** Setzt/entfernt die bgOverride-Farbe nachträglich (z. B. Aufnahme-Blinken). */
export function setButtonOverride(button: HTMLButtonElement, color: string | null): void {
  if (color === null) {
    button.classList.remove('cm-btn--override');
    button.style.removeProperty('--cm-btn-bg');
    return;
  }
  button.classList.add('cm-btn--override');
  button.style.setProperty('--cm-btn-bg', color);
}

/** DrawPlayStopIcon(): grün = bereit/klick zum Starten, rot = läuft/klick zum Stoppen. */
const PLAY_BG = '#109a4a';
const STOP_BG = '#c03030';

/** Glyph + Farbe einer Play/Stop-Schaltfläche (TxMessageWindow.cpp:103). */
export function setPlayStopState(button: HTMLButtonElement, running: boolean): void {
  button.textContent = running ? '\u25a0' : '\u25b6';
  setButtonOverride(button, running ? STOP_BG : PLAY_BG);
}
